import React, { Component } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { fetchTradeOffers } from '../../../../actions/tradeOffersActions';
import { connect } from 'react-redux';
import { tooltipShow } from '../../../../actions/tooltipActions';
import CheckIfAnyData from '../../../shared/CheckIfAnyData';
import Spinner from '../../../shared/_Spinner';
import TradeOffersReceivedDesktop from './TradeOffersReceivedDesktop';
import TradeOffersReceivedMobile from './TradeOffersReceivedMobile';
import TradeOffersRequestedDesktop from './TradeOffersRequestedDesktop';
import TradeOffersRequestedMobile from './TradeOffersRequestedMobile';
import { isMobile } from '../../../../lib/responsive';

class Pending extends Component {
    _renderReceivedTrades = () => {
      const { tradeOffersReceived, loading } = this.props;
      const TradeOffersReceived = isMobile ? TradeOffersReceivedMobile : TradeOffersReceivedDesktop;

      return (
        <React.Fragment>
          <div className={ 'trade-post__title' }>Received</div>
          { !isMobile && (
            <div className='trade-post__header'>
              <div className='trade-post__header-item trade-post__office'>Office</div>
              <div className='trade-post__header-item trade-post__requester'>Requester</div>
              <div className='trade-post__header-item trade-post__offered-appt'>Offered Appt</div>
              <div className='trade-post__header-item trade-post__requested-appt'>Requested Appt</div>
              <div className='trade-post__header-item trade-post__status' />
            </div>
          )}
          <Spinner enabled={ loading }>
            <CheckIfAnyData dataSize={ tradeOffersReceived.size } message={'There are no trade offers'}>
              <TradeOffersReceived onHandleShowTradeAcceptModal={ this._handleShowTradeAcceptModal }
                tradeOffersReceived={ tradeOffersReceived } />
            </CheckIfAnyData>
          </Spinner>
        </React.Fragment>
      );
    };

    _renderRequestedTrades = () => {
      const { tradeOffersRequested, loading } = this.props;
      const TradeOffersRequested = isMobile ? TradeOffersRequestedMobile : TradeOffersRequestedDesktop;

      return (
        <React.Fragment>
          <div className={ 'trade-post__title' }>Requested</div>
          { !isMobile && (
            <div className='trade-post__header'>
              <div className='trade-post__header-item trade-post__office'>Office</div>
              <div className='trade-post__header-item trade-post__receiver'>Receiver</div>
              <div className='trade-post__header-item trade-post__offered-appt'>Offered Appt</div>
              <div className='trade-post__header-item trade-post__requested-appt'>Requested Appt</div>
              <div className='trade-post__header-item trade-post__status'>Status</div>
              <div className='trade-post__header-item trade-post__status'></div>
            </div>
          )}
          <Spinner enabled={ loading }>
            <CheckIfAnyData dataSize={ tradeOffersRequested.size } message={'There are no trade offers'}>
              <TradeOffersRequested onHandleShowTradeAcceptModal={ this._handleShowTradeAcceptModal }
                tradeOffersRequested={ tradeOffersRequested } />
            </CheckIfAnyData>
          </Spinner>
        </React.Fragment>
      );
    };

    _handleShowTradeAcceptModal = (id) => () => {
      const { showModal } = this.props;

      showModal(id);
    };

    componentDidMount() {
      const { tradeOffersFetch } = this.props;

      tradeOffersFetch({ status: 'pending' });
    }

    render() {
      return (
        <div className='trade-post'>
          {this._renderReceivedTrades()}
          {this._renderRequestedTrades()}
        </div>

      );
    }
}

Pending.propTypes = {
  loading: PropTypes.bool,
  showModal: PropTypes.func.isRequired,
  tradeOffersFetch: PropTypes.func.isRequired,
  tradeOffersReceived: PropTypes.instanceOf(Immutable.Map).isRequired,
  tradeOffersRequested: PropTypes.instanceOf(Immutable.Map).isRequired
};

const mapStateToProps = (state) => ({
  tradeOffersReceived: state.getIn(['tradeOffers', 'data', 'receivedTrades'], Immutable.Map()),
  tradeOffersRequested: state.getIn(['tradeOffers', 'data', 'requestedTrades'], Immutable.Map()),
  loading: state.getIn(['tradeOffers', 'loading'])

});

const mapDispatchToProps = (dispatch) => ({
  tradeOffersFetch: (params) => dispatch(fetchTradeOffers(params)),
  showModal: (id) => dispatch(tooltipShow({ id }))
});

export default connect(mapStateToProps, mapDispatchToProps)(Pending);



// WEBPACK FOOTER //
// ./app/components/reps/trade_post/pending/Pending.jsx